const maskedNumberNormalizer = maskedNumber => maskedNumber.replace(/X/g, '*');

export default maskedNumberNormalizer;
